import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function HideAIBotWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    const hidePaths = [
      "/training",
      "/accounting-course",
      "/professional-taxation-training",
      "/professional-business-courses",
      "/professional-management-training",
      "/training-about-us",
    ];

    const aiBotElement = document.getElementById("ai-bot");
    if (aiBotElement) {
      if (hidePaths.includes(location.pathname)) {
        aiBotElement.style.display = "none";
      } else {
        aiBotElement.style.display = "block";
      }
    }
  }, [location.pathname]);

  return children;
}

export default HideAIBotWrapper;
